import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Label } from '@models/admin-users';
import { ToastService } from '@services/toastService/toastMessage.service';

/**
 * Add Editorial and Legal labels
 *
 */

@Component({
    selector: 'app-add-labels',
    templateUrl: './add-labels.component.html'
    // see styles/ng-zorro/nz-modal.scss for global styles
    ,
    standalone: false
})
export class AddLabelsComponent implements OnInit {

  @Input() addLabelsVisible;

  @Input() isNewLabel;

  @Input() editLabels;

  @Input() typeOfLabel;

  @Output() closeLabels: EventEmitter<any> = new EventEmitter<any>();

  @Output() updatedLabels: EventEmitter<any> = new EventEmitter<any>();

  @Output() emitNewLabel: EventEmitter<any> = new EventEmitter<any>();

  @Output() addedLabelType: EventEmitter<any> = new EventEmitter<any>();

  newMarkAsLabel = [];

  newStatusLabel = [];

  labelObj = {} as Label;

  selectedValue = 'markAs';

  labelName = '';

  labelType = 'Mark As';

  constructor(
    private toastService: ToastService
  ) { }

  ngOnInit() {

    this.labelObj.value = '';
    this.labelObj.label = '';
    this.labelObj.inActive = false;

  }

  handleOk() {

    this.closeLabels.emit(true);
    this.updatedLabels.emit({ updatedLabels: this.editLabels, type: this.typeOfLabel });

  }

  addLabel() {

    if (this.selectedValue === 'status') {

      if (this.labelName !== '') {

        this.newStatusLabel.push(this.labelObj);
        this.emitNewLabel.emit({ newArray: this.newStatusLabel, type: this.labelType });
        this.closeLabels.emit(true);
        this.labelName = '';

      } else {

        this.toastService.createMessage('warning', 'Label Name cannot be Empty');

      }

    } else if (this.selectedValue === 'markAs') {

      if (this.labelName !== '') {

        this.newMarkAsLabel.push(this.labelObj);
        this.emitNewLabel.emit({ newArray: this.newMarkAsLabel, type: this.labelType });
        this.closeLabels.emit(true);
        this.labelName = '';

      } else {

        this.toastService.createMessage('warning', 'Label Name cannot be Empty');

      }

    }

  }

  handleCancel() {

    this.labelObj.label = '';
    this.labelObj.value = '';
    this.labelName = '';
    this.selectedValue = 'markAs';
    this.closeLabels.emit(true);

  }

  changeLabelName(value) {

    console.log('Label Name', value);
    this.labelObj.label = value.toUpperCase();
    this.labelObj.value = value.toUpperCase();
    this.labelObj.inActive = false;

  }

  changedType(value) {

    console.log('Changed Value', value);
    if (value === 'status') {

      this.labelType = 'Status';

    } else if (value === 'markAs') {

      this.labelType = 'Mark As';

    }

  }

  changeLabelStatus(val, item) {

    console.log('Value changes', val, item);
    if (val === false) {

      item.inActive = true;

    } else if (val === true) {

      item.inActive = false;

    }

  }

}
